// src/components/AdminNavBar.js
import React, { useContext } from "react";
import { AppBar, Toolbar, Button, IconButton, Tooltip, Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { useTheme } from "@mui/material/styles";
import { ColorModeContext } from "../App";

export default function AdminNavBar({ onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const { mode, toggleColorMode } = useContext(ColorModeContext);

  const currentTab = location.pathname.startsWith("/admin-chat")
    ? "chat"
    : location.pathname.startsWith("/users")
    ? "users"
    : "dashboard";

  return (
    <AppBar position="static" color="default">
      <Toolbar>
        <Button
          color={currentTab === "dashboard" ? "primary" : "inherit"}
          onClick={() => navigate("/dashboard")}
        >
          Ταμπλό
        </Button>
        <Button
          color={currentTab === "users" ? "primary" : "inherit"}
          onClick={() => navigate("/users")}
        >
          Χρήστες
        </Button>
        <Button
          color={currentTab === "chat" ? "primary" : "inherit"}
          onClick={() => navigate("/admin-chat")}
        >
          Admin Chat
        </Button>

        <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 1 }}>
          <Tooltip title={mode === "dark" ? "Φωτεινό θέμα" : "Σκούρο θέμα"}>
            <IconButton onClick={toggleColorMode} color="inherit" aria-label="toggle theme">
              {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
            </IconButton>
          </Tooltip>

          <Button color="secondary" onClick={onLogout}>
            Logout
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
